<template>
  <div v-click-outside="close">
    <b-popover
      :target="`popover-detail-${selectedEvent.id}`"
      triggers="click"
      :show.sync="popoverShow"
      :placement="placement"
      custom-class="popup-detail-wrapper"
      ref="popover"
      :offset="10"
      boundary="window"
      container="calendar-wrapper"
    >
      <div>
        <div v-if="isLoading" class="event-content">
          <div class="info-wrapper">
            <div>
              <b-skeleton width="50%"></b-skeleton>
            </div>
            <div class="info-item">
              <b-skeleton width="35%"></b-skeleton>
              <b-skeleton width="35%"></b-skeleton>
            </div>
            <div class="info-item">
              <b-skeleton width="30%"></b-skeleton>
              <b-skeleton width="30%"></b-skeleton>
            </div>
            <div class="info-item">
              <b-skeleton width="25%"></b-skeleton>
              <b-skeleton width="25%"></b-skeleton>
            </div>
          </div>
        </div>
        <div v-else class="event-content">
          <div class="info-wrapper">
            <div class="info-item">
              <div class="info-title">
                หมายเลขการจอง ({{ bookingDetail.invoiceNo }})
              </div>
              <font-awesome-icon
                class="cursor-pointer"
                :icon="['fas', 'times']"
                @click="close"
              />
            </div>
            <div class="info-item">
              <div class="name">สถานะ:</div>
              <div class="value">
                <div
                  class="status px-1"
                  :style="{
                    color: bookingDetail.calendarPrimaryColor,
                    backgroundColor: bookingDetail.calendarSecondaryColor,
                    borderColor: bookingDetail.calendarPrimaryColor,
                    borderLeft: `8px solid ${bookingDetail.calendarPrimaryColor}`,
                  }"
                >
                  {{ bookingDetail.statusName }}
                </div>
              </div>
            </div>
            <div class="info-item">
              <div class="name">สถานที่:</div>
              <div class="value">{{ bookingDetail.venueName }}</div>
            </div>
            <div class="info-item">
              <div class="name">บริการ:</div>
              <div class="value">{{ bookingDetail.eventName }}</div>
            </div>
            <div class="info-item">
              <div class="name">TICKET/จำนวน</div>
              <div class="value">
                <div
                  v-for="product in bookingDetail.productTable"
                  :key="product.id"
                >
                  <div class="d-flex justify-content-between">
                    <div>
                      {{ product.productName }} ({{
                        formatNumber(product.price)
                      }}
                      บาท)
                    </div>
                    <div class="ml-2">X{{ product.quantity }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-item">
              <div class="name">รอบวันที่/เวลา:</div>
              <div class="value">
                {{ $moment(bookingDetail.bookingDate).format("DD/MM/YYYY") }}
                {{ bookingDetail.startTimeShow }}-{{
                  bookingDetail.endTimeShow
                }}
              </div>
            </div>
            <div class="info-item">
              <div class="name">ยืนยันโดย:</div>
              <div class="value">
                {{ bookingDetail.confirmBy || "-" }}
              </div>
            </div>

            <div class="info-item">
              <div class="name">หมายเหตุเพิ่มเติม:</div>
              <div class="value">{{ bookingDetail.note || "-" }}</div>
            </div>
            <div class="info-item" v-if="bookingDetail.displayCanceledNote">
              <div class="name">เหตุผลในการยกเลิก:</div>
              <div class="value">{{ bookingDetail.canceledNote || "-" }}</div>
            </div>
          </div>
          <div class="info-wrapper">
            <div>
              <div class="info-title">ข้อมูลผู้รับบริการ</div>
            </div>
            <div class="info-item">
              <div class="name">ชื่อผู้รับบริการ:</div>
              <div class="value">{{ bookingDetail.fullName }}</div>
            </div>
            <div class="info-item">
              <div class="name">หมายเลขสมาชิก:</div>
              <div class="value">{{ bookingDetail.memberId || "-" }}</div>
            </div>
            <div class="info-item">
              <div class="name">เบอร์โทรศัพท์:</div>
              <div class="value">{{ bookingDetail.telephone }}</div>
            </div>
          </div>
          <div class="info-wrapper">
            <div class="info-item">
              <div class="info-title">การชำระเงิน</div>
              <div class="info-title">
                <u
                  class="cursor-pointer"
                  v-if="bookingDetail.paymentTypeId === 1"
                  @click="$bvModal.show('modal-confirm-payment')"
                  >รายละเอียด</u
                >
              </div>
            </div>
            <div class="info-item">
              <div class="name">คูปอง:</div>
              <div class="value">{{ bookingDetail.promoCodeName || "-" }}</div>
            </div>
            <div class="info-item">
              <div class="name">สถานะ:</div>
              <div class="value">{{ bookingDetail.paymentTypeName }}</div>
            </div>
          </div>
          <div class="info-item">
            <b-button
              variant="outline-primary"
              :class="{
                'mx-auto': ![3, 4].includes(bookingDetail.customerFlowStatusId),
              }"
              @click="close"
            >
              ปิด
            </b-button>
            <b-button
              variant="outline-primary"
              v-if="[4].includes(bookingDetail.customerFlowStatusId)"
              @click="onClickCancel"
            >
              REJECT
            </b-button>
            <b-button
              variant="outline-primary"
              v-if="[3].includes(bookingDetail.customerFlowStatusId)"
              @click="handleNoShow"
            >
              NO SHOW
            </b-button>
            <b-button
              variant="primary"
              v-if="[3].includes(bookingDetail.customerFlowStatusId)"
              @click="handleComplete"
            >
              COMPLETE
            </b-button>
            <b-button
              variant="primary"
              v-if="[4].includes(bookingDetail.customerFlowStatusId)"
              @click="openConfirmPopup"
            >
              CONFIRM
            </b-button>
          </div>
        </div>
      </div>
    </b-popover>

    <ModalConfirmPayment
      :dataPayment="dataPayment"
      @confirmSuccess="confirmSuccess"
    />
    <ModalTextArea
      id="cancel"
      ref="cencelModalT"
      text="ต้องการยกเลิกการจองใช่หรือไม่"
      @handler="handleCancel"
      showIcon
      label="เหตุผลในการยกเลิก"
      placeholder="กรุณาระบุเหตุผลในการยกเลิก"
    />
    <ModalUserConfirm ref="modalUserConfirm" @select="handleConfirm" />
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import ModalConfirmPayment from "@/components/modal/ModalConfirmPayment.vue";
import ModalTextArea from "@/components/modal/ModalTextArea";
import ModalUserConfirm from "./ModalUserConfirm.vue";
export default {
  components: {
    FullCalendar,
    ModalConfirmPayment,
    ModalTextArea,
    ModalUserConfirm,
  },
  props: {
    placement: {
      required: false,
      type: String,
      default: "right",
    },
  },
  data() {
    return {
      popoverShow: false,
      bookingDetail: {},
      isLoading: false,
      dataPayment: null,
      selectedEvent: {},
    };
  },
  watch: {},
  methods: {
    async openConfirmPopup() {
      this.$refs.modalUserConfirm.show();
    },
    async handleConfirm(user) {
      const respone = await this.$services.transaction.confirmTransaction(
        this.selectedEvent.id,
        { userId: user.userId }
      );
      this.confirmSuccess();
    },
    async handleComplete() {
      const respone = await this.$services.transaction.completeTransaction(
        this.selectedEvent.id,
        this.bookingDetail
      );
      this.confirmSuccess();
    },
    async handleNoShow() {
      const respone = await this.$services.transaction.noShowTransaction(
        this.selectedEvent.id,
        this.bookingDetail
      );
      this.confirmSuccess();
    },
    formatNumber(val) {
      return this.$services.utils.formatNumber(val);
    },
    onClickCancel() {
      this.$refs.cencelModalT.show();
    },
    async handleCancel(val, text) {
      if (val === true) {
        const respone = await this.$services.transaction.cancelTransaction(
          this.selectedEvent.id,
          text
        );
        this.confirmSuccess();
      } else {
        this.$refs.cencelModal.close();
      }
    },
    async getPaymentInfo() {
      const getData = await this.$services.transaction.getPaymentInfo(
        this.selectedEvent.id
      );

      if (getData.result == 1) {
        getData.detail.bankTransferList = getData.detail.bankTransferList.map(
          (x) => {
            x.transactionDetail.dateOnly = x.transactionDetail.dateOnly
              .split("-")
              .reverse()
              .join("-");

            let obj = {
              ...x,
              base64: {
                base64: null,
              },
              imageName: x.transactionDetail.slipImgUrl.split("/").reverse()[0],
            };
            x.transactionDetail.timeOnly = this.convertTime(
              x.transactionDetail.timeOnly
            );

            return obj;
          }
        );

        this.dataPayment = getData.detail;
      }
    },
    convertTime(time) {
      let getTime = `${this.$moment().format("YYYY-MM-DDT")}${time}`;

      return getTime;
    },
    async getDetailTransaction() {
      this.isLoading = true;
      let payload = {};
      if (this.$isEventGroup !== undefined) {
        payload = {
          isEventGroup: this.$isEventGroup,
        };
      }

      const getData = await this.$services.transaction.getTransactionDetail(
        this.selectedEvent.id,
        payload
      );

      if (getData.result == 1) {
        this.bookingDetail = getData.detail;
      }
      this.isLoading = false;
    },

    show(id) {
      this.handleShowPopup(id);
    },

    confirmSuccess() {
      this.$emit("confirmSuccess");
      this.close();
    },

    close() {
      this.popoverShow = false;
    },

    handleShowPopup(id) {
      this.popoverShow = false;
      if (!id) return;

      this.selectedEvent = { id };
      setTimeout(() => {
        this.popoverShow = true;
      }, 300);

      this.getDetailTransaction();
      this.getPaymentInfo();
    },
  },
};
</script>

<style lang="scss">
.calendar-wrapper {
  border: 1px solid var(--fc-border-color);
  border-radius: 10px;
  background-color: white;

  .custom-header {
    display: flex;
    justify-content: space-between;
    padding: 16px 16px 0 16px;
    align-items: center;

    .title {
      font-size: 1.25rem;
    }

    .left {
      display: flex;
      gap: 16px;
      align-items: center;
    }

    .navigation {
      display: flex;
      gap: 4px;

      button {
        border-radius: 50%;
      }
    }
  }
}
.app-calendar {
  //   height: calc(100vh - 265px);

  thead {
    background-color: white;
  }

  table {
    border-color: transparent !important;
    border-spacing: 0;
  }

  table:not([cellpadding]) td {
    padding-left: 0;
    padding-right: 0;
  }

  th {
    padding-bottom: 0 !important;
    border: none;
    border-bottom: 1px solid var(--fc-border-color);
  }

  .fc-col-header-cell-cushion {
    flex: 1 1;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 12px 0;
    gap: 4px;

    .day-name {
      text-transform: uppercase;
      font-size: 0.75rem;
      color: #79747e;
      font-weight: 500;
    }

    .day-number {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.25rem;
      font-weight: 500;
      color: #79747e;
      height: 2em;
      width: 2em;
    }
  }
}

.calendar-event {
  height: 100%;
  border-left: 8px solid;
  padding: 8px 4px;
  cursor: pointer;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .name {
    font-weight: bold;
    margin-top: 8px;
    font-size: 14px;
    text-transform: uppercase;
  }
}

.event-popover {
  position: absolute;
  background-color: white;
  padding: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  width: 350px;
}

.event-content {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .info-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .info-title {
      font-weight: bold;
      color: black;
    }
  }

  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: start;

    .value {
      font-weight: bold;
    }
  }
}

.self-center {
  align-self: center;
}

.popup-detail-wrapper {
  min-width: 350px;
  min-height: 400px;
}
</style>
